import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const Wrapper = styled('div')`
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    height: 100%;
    color: var(--text-color-dark);

    .page-filters {
        display: flex;
        align-items: center;

        .filters {
            display: flex;
            align-items: center;
            gap: 2px;
        }

        .filter:hover {
            background-color: var(--color-dark-700);
        }

        .filter.is-active {
            color: var(--color-dark-800);
            background-color: var(--color-primary);
        }
    }

    .filters-group {
        min-width: 180px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin-bottom: 28px;

        .filter-name {
            font-weight: 700;
            font-size: var(--font-size-xs);
            line-height: 15px;
            color: var(--color-greys-200);
            margin-bottom: 8px;
        }
    }

    i.separator {
        display: block;
        margin-block: 12px;
        @include item-border($size: 1px, $color: var(--color-dark-400));
    }
`
export const Header = styled('div')`
    display: flex;
    align-items: center;
    padding: 36px 0;
    border-bottom: 4px solid var(--color-greys-50);
`

export const Subtitle = styled(Typography)`
    margin-bottom: 28px;
`

export const DescriptionFlex = styled('div')`
    display: flex;
    gap: 30px;
    margin: 20px 0;
`

export const Footer = styled('div')`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 36px 0;
    border-top: 4px solid var(--color-greys-50);
`
